import type { ReactNode, CSSProperties } from "react";

export const enum CornerPos {
  leftTop = "leftTop",
  rightTop = "rightTop",
  leftBottom = "leftBottom",
  rightBottom = "rightBottom",
}

export interface CoverProps {
  src: string;
  width: number;
  auto?: boolean;
  height?: number;
  className?: string;
  children?: ReactNode;
  style?: CSSProperties;
  alt?: string;
  imgClassName?: string;
}

export interface CoveringCornerProps {
  className?: string;
  position: CornerPos;
  backgroundColor?: string;
  children: ReactNode;
}

export interface CoveringBottomProps {
  backgroundColor?: string;
  color?: string;
  children: ReactNode;
}
